
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
Tabbar,
TabbarItem,
Group,
Cell
},
data () {
return {

}
},
props: {
page: {
type: Number
}
}
}



// WEBPACK FOOTER //
// ./src/components/tabbar.vue